import * as React from 'react'
import { Chip, Box } from '@mui/material'
import { formatDate } from "@ui-seeker/utils"


export default function lastExtractionColumn() {
    return {
        name: 'lastExtraction', label: 'Last Extraction',
        options: {
            filter: false,
            customBodyRowRender: (value, row) => <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {formatDate(value, {isString: true})}
            </Box> 
        }
    }
}
